import axios from "axios";

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_APP_API_URL,
});

export const addAccessTokenInterceptor = (getAccessTokenSilently: () => void) => {
    axiosInstance.interceptors.request.use(async (config) => {
      const token = await getAccessTokenSilently()
      config.headers['authorization'] = 'Bearer ' + token
      return config
    })
  }

axiosInstance.interceptors.response.use(function (response) {
    return response
  }, function (error) {
    if(Boolean(error.response) && Boolean(error?.response?.data?.title)) {
      error.message = error.response.data.title
    }
  
    return Promise.reject(error)
  })

export default axiosInstance;
